import { useEffect } from "react";
import { useMessageContext } from "../../hooks/MessageContext";
import ChatNavigation from "../chat/chat-navigation";
import ChatMessagesLayout from "./chat-messages-layout";

function MainLayout() {
  // Add spacing for both header and chat input
  const headerHeight = "4rem";
  const chatInputHeight = "5rem";

  const { setChatType } = useMessageContext();

  useEffect(() => {
    setChatType("ai_chat");
  }, [setChatType]);

  return (
    <main
      className="max-w-8xl mx-auto px-4 py-8 sm:px-6 lg:px-8"
      style={{ height: "var(--app-height)" }}
    >
      <ChatNavigation />
      <div
        className="relative h-full"
        style={{
          height: `calc(var(--app-height) - ${headerHeight} - ${chatInputHeight})`,
          marginBottom: chatInputHeight,
        }}
      >
        <ChatMessagesLayout />
      </div>
    </main>
  );
}

export default MainLayout;
